import { render, staticRenderFns } from "./DevBpbjStandardInfoList.vue?vue&type=template&id=49e563fe&scoped=true&"
import script from "./DevBpbjStandardInfoList.vue?vue&type=script&lang=js&"
export * from "./DevBpbjStandardInfoList.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjStandardInfoList.vue?vue&type=style&index=0&id=49e563fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e563fe",
  null
  
)

export default component.exports